import React from "react";
import { cn } from "../../../utils/cn";

export type SectionShellProps = {
  title: string;
  description?: string;
  children: React.ReactNode;
  className?: string;
};

export const SectionShell: React.FC<SectionShellProps> = ({
  title,
  description,
  children,
  className,
}) => (
  <section className={cn("space-y-6 border-b border-solid border-[#E2E8F0] pb-12", className)}>
    <header className="space-y-2">
      <h2 className="text-lg font-semibold text-[#1A202C]">{title}</h2>
      {description ? (
        <p className="max-w-3xl text-sm leading-relaxed text-[#4A5568]">{description}</p>
      ) : null}
    </header>
    {children}
  </section>
);
